import { axiosInstance } from '~/services/fetchServiceV2';

import { useDedupeMutation } from '../common';

/** @category useLeaveWork */
export type TypeLeaveWorkParams = {
  /** 계정 코드 */
  laborAccountId: number;
};

/** @category useLeaveWork */
export type TypeLeaveWorkResponse = {
  /** 근무한 시간 */
  workingHour: number;
  /** 근무한 분 */
  workingMinute: number;
  /** 출근 시각 */
  startWorkTime: string;
  /** 퇴근 시각 */
  endWorkTime: string;
};

/**
 * @description 퇴근 처리 api 요청에 사용되는 커스텀 훅
 */
export const useLeaveWork = () => {
  const [requestLeaveWork] = useDedupeMutation<TypeLeaveWorkParams, TypeLeaveWorkResponse>({
    mutationFn: (params: TypeLeaveWorkParams) => {
      const endpoint = '/commute/end-commute';
      return axiosInstance.post<TypeLeaveWorkResponse>(endpoint, params);
    },
  });

  return requestLeaveWork;
};
